import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { sampleTypeLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/local-samples/local-sample-types/services/local-sample-types.service'
import { store } from '@/store/store'
import { ConfigurationSampleTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/local-sample-types/services/local-sample-types.dto'

export const columnsDefTextLocalSampleTypesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'sampleType.description',
            minWidth: 150,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.processingRequired'),
            field: 'processingRequired',
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.daysToDelete'),
            colId: 'daysToDelete',
            field: 'defaultDaysBeforeDisposal',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface LocalSampleTypesGridState extends CrudModelPaginatorLaboratory<ConfigurationSampleTypeLaboratoryResponse> {
    labId: number
}
export const initialLocalSampleTypesGridState =
    (): LocalSampleTypesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.localSamples.localSampleTypes',
        columnsDef: columnsDefTextLocalSampleTypesGrid(),
        datasource: new PaginatorLaboratoryDatasource(sampleTypeLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
